import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

function Subscribe() {
  const { theme } = useTheme();
  const tokens = theme.tokens;
  const tc = tokens.colors;

  const cardStyle = {
    background: `color-mix(in srgb, ${tc.surface} 75%, transparent)`,
    backdropFilter: 'blur(2px)',
    WebkitBackdropFilter: 'blur(6px)',
    border: `1px solid ${tc.gridLine}`,
    borderRadius: 14,
    padding: '32px 36px',
    marginTop: 24,
  };

  const h1Style = {
    fontFamily: tokens.fonts.display,
    fontSize: 'clamp(24px, 5vw, 32px)',
    fontWeight: 600,
    color: tc.ink,
    marginBottom: 20,
    lineHeight: 1.2,
  };

  const h2Style = {
    fontFamily: tokens.fonts.display,
    fontSize: 20,
    fontWeight: 600,
    color: tc.ink,
    marginTop: 28,
    marginBottom: 10,
  };

  const linkStyle = { color: tc.accent };

  return (
    <div className="container mx-auto px-4 sm:px-8 pb-12" style={{ color: tc.muted, fontFamily: tokens.fonts.ui, textAlign: 'left' }}>
      <Helmet>
        <title>Subscribe to the Atlanta Tech Events Newsletter | ATLTech.events</title>
        <meta name="description" content="Get a weekly newsletter of upcoming Atlanta tech meetups and events delivered to your inbox. Free to subscribe, unsubscribe any time." />
      </Helmet>
      <div style={cardStyle}>
        <h1 style={h1Style}>Subscribe to ATLTech<span style={{ color: tc.accent, fontFamily: theme.tokens.fonts.ui }}>.events</span><sup>SM</sup></h1>

        <div className="space-y-4">
          <p>
            We've also launched a newsletter to keep you updated on the latest events and news in the tech community.
          </p>
          <p>
            <a href="https://eventhorizonmedia.substack.com/s/atl-tech-events" target="_blank" rel="noopener noreferrer" style={linkStyle} className="hover:underline">
              Subscribe to the ATLTech.events newsletter
            </a>
          </p>
          <p>
            We'll publish a weekly newsletter with the upcoming events for the week. It's free and you can unsubscribe at any time. Paid subscriptions are available to support our work.
          </p>
          <p>
            Our newsletter is produced by Event Horizon Media, a media service of Mirability, LLC. Through Event Horizon Media, we'll be able to expand to different cities and event types. Interested in a specific event type or city? Let us know!
          </p>

          <h2 style={h2Style}>Event Horizon Media<sup>SM</sup></h2>
          <p className="flex justify-center">
            <img src="event-horizon-media-logo.png" alt="Event Horizon Media Logo" className="w-1/2 rounded-full" />
          </p>
          <p>
            Event Horizon Media is a media and event platform service of Mirability, LLC, that produces the ATLTech.events calendar and newsletter. Want to see the platform in your city? Let us know!
          </p>
        </div>
      </div>
    </div>
  );
}

export default Subscribe;
